if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        if (this.prevButton) this.prevButton.addEventListener('click', () => this.navigate(-1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.navigate(1));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showMedia(this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`));
      }

      navigate(step) {
        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeIndex = mediaElements.findIndex((element) => element.classList.contains('active'));
        const nextIndex = (activeIndex + step + mediaElements.length) % mediaElements.length;
        this.showMedia(mediaElements[nextIndex]);
      }

      showMedia(activeMedia) {
        this.querySelectorAll('[data-media-id].active').forEach((element) => {
          element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
